import service from "../baseHttpService";
import { MerchantId, SetHeaderService } from "@/helper/userHelper";

class AllocationService {
  DoGetAllocationList() {
    const _input = {
      merchantId: MerchantId(),
      isUseMainDatabase: true,
    };
    return service.peakExportAPI
      .post("/api/Allocation/GetAllocationList", _input, SetHeaderService())
      .then((res) => {
        return res;
      })
      
  }
  DoGetAllocationItemList(allocationId: number) {
    const _input = {
      merchantId: MerchantId(),
      allocationId: allocationId,
      isUseMainDatabase: true,
    };
    return service.peakExportAPI
      .post("/api/Allocation/GetAllocationItemList", _input, SetHeaderService())
      .then((res) => {
        return res;
      })
      
  }
}

export default new AllocationService();
